import { FC, useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import { useActiveFeventListForWorkerHook } from '@shared/api/fevent/fevent.hook';
import { FeventList } from '@shared/api/fevent/fevent.interface';
import { activeFeventListForWorkerStateSelector } from '@shared/api/fevent/fevent.selector';
import { Button } from '@shared/components/Button';
import { searchTextAtomFamily } from '@shared/containers/SearchBar/state/searchBar.atom';
import { useAuth } from '@shared/state/hooks/useAuth';
import FuzzySearch from 'fuzzy-search';

import SearchBar from '../../../@shared/containers/SearchBar/SearchBar';
import { BugoCard } from '../components/BugoCard';
import { useTitleHook } from '../hooks/useTitleHook';

/**
 * 부고 관리 (리스트) 페이지
 * @returns page, container
 */

const SEARCH_TEXT_ID = 'bugoManagePage';

//*지도사용 부고관리 페이지
const FeventManagePage: FC = function FeventManagePage() {
  useTitleHook('부고 관리', undefined, undefined, true, '/');

  const { isAdmin } = useAuth();

  //* 지도사용
  useActiveFeventListForWorkerHook();

  const feventListForWorkerState = useRecoilValue(activeFeventListForWorkerStateSelector);

  const searchText = useRecoilValue(searchTextAtomFamily(SEARCH_TEXT_ID));

  const feventList = useMemo(() => {
    if (feventListForWorkerState.status === 'success' && feventListForWorkerState.data) {
      return feventListForWorkerState.data;
    } else return [];
  }, [feventListForWorkerState.data, feventListForWorkerState.status]);

  //* 검색 결과는 파생값이므로 useMemo로 계산 (useState + useEffect 조합은 렌더 루프 유발)
  const searchedList: FeventList = useMemo(() => {
    // text가 빈 문자열이라면 feventList 전체 리턴.
    if (searchText.length === 0) return feventList;
    const searcher = new FuzzySearch(
      feventList,
      [
        'deceasedInfo.name',
        'memberOrderList.fullName',
        'funeralHomeInfo.name',
        'roomInfo.name',
        'user.info.name',
        'user.info.phoneNumber',
      ],
      {
        caseSensitive: true,
      },
    );
    return searcher.search(searchText);
  }, [searchText, feventList]);

  return (
    <div className="px-4 pb-10">
      {/* Search Bar */}
      <div className="px-2 py-4">
        <SearchBar
          searchTextAtomId={SEARCH_TEXT_ID}
          placeholder="성함/장례식장/호실로 검색하세요."
        />
      </div>
      {/* BugoCards */}
      <div className="space-y-3">
        {searchedList.map((fevent) => (
          <BugoCard fevent={fevent} key={'bugocard' + fevent._id} />
        ))}
      </div>
      {isAdmin() && (
        <div className="fixed bottom-20 right-10 flex flex-col items-center justify-center gap-4 rounded-lg border bg-white p-4">
          <Button
            className="shadow-sm"
            onClick={() => {
              window.scrollTo(0, 0);
            }}
          >
            top
          </Button>
          <Button
            className="shadow-sm"
            onClick={() => {
              window.scrollTo(0, document.body.scrollHeight);
            }}
          >
            bot
          </Button>
        </div>
      )}
    </div>
  );
};

export default FeventManagePage;
